"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ImageFiltersButton = _interopRequireDefault(require("./ImageFiltersButton"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingLeft: "50%",
    paddingRight: theme.spacing(1),
    overflowX: "scroll"
  }
}));

const FilterOptions = ({
  className,
  imageFilters,
  imageUrl,
  options = [],
  onChange
}) => {
  const classes = useStyles();

  const applyFilter = ({
    imageFilters
  }) => {
    onChange && onChange(imageFilters);
  };

  return _react.default.createElement("footer", {
    className: className || classes.root
  }, options.map((option, index) => {
    const selected = imageFilters === option.imageFilters;
    return _react.default.createElement(_ImageFiltersButton.default, _extends({}, option, {
      imageUrl: imageUrl,
      selected: selected,
      key: index,
      onClick: () => applyFilter(option)
    }));
  }));
};

FilterOptions.defaultProps = {
  options: [{
    label: "Original",
    imageFilters: {}
  }, {
    label: "Grayscale",
    imageFilters: {
      grayscale: true
    }
  }, {
    label: "Vignette",
    imageFilters: {
      vignette: true
    }
  }, {
    label: "Duotone",
    imageFilters: {
      duotone: true
    }
  }, {
    label: "Max contrast",
    imageFilters: {
      contrast: 100
    }
  }, {
    label: "Min contrast",
    imageFilters: {
      contrast: -50
    }
  }, {
    label: "Max bright",
    imageFilters: {
      brightness: 50
    }
  }, {
    label: "Min bright",
    imageFilters: {
      brightness: -50
    }
  }, {
    label: "Blur 0",
    imageFilters: {
      blur: 0
    }
  }, {
    label: "Blur 1",
    imageFilters: {
      blur: 1
    }
  }, {
    label: "Blur 2",
    imageFilters: {
      blur: 2
    }
  }]
};
var _default = FilterOptions;
exports.default = _default;
module.exports = exports.default;